import { Injectable } from '@angular/core';
import {SearchParam} from "../../defines/client.const";

@Injectable({
  providedIn: 'root'
})
export class LastIdService {

  constructor() { }

  /******************************************************************************
   * Word
   *****************************************************************************/

  private lastDetailWordId: string | null = null;
  private lastListWordId: string | null = null;

  public setLastWordId(detail_id: string | null, list_id: string | null): void {
    // console.warn('setLastWordId', detail_id, list_id)
    this.lastDetailWordId = detail_id;
    this.lastListWordId = list_id;
  }

  public getLastWordId(): [string | null, string | null] {
    // console.warn('getLastWordId', this.lastDetailWordId, this.lastListWordId)
    // return [this.lastDetailWordId, this.lastListWordId];
    return [null, this.lastListWordId];
  }

  public clearLastWordId(): void {
    this.lastDetailWordId = null;
    this.lastListWordId = null;
  }

  /******************************************************************************
   * Homonym
   *****************************************************************************/

  private lastDetailHomonymId: string | null = null;
  private lastListHomonymId: string | null = null;

  public setLastHomonymId(detail_id: string | null, list_id: string | null): void {
    // console.warn('setLastHomonymId', detail_id, list_id)
    this.lastDetailHomonymId = detail_id;
    this.lastListHomonymId = list_id;
  }

  public getLastHomonymId(): [string | null, string | null] {
    // console.warn('getLastHomonymId', this.lastDetailHomonymId, this.lastListHomonymId)
    // return [this.lastDetailHomonymId, this.lastListHomonymId];
    return [null, this.lastListHomonymId];
  }

  public clearLastHomonymId(): void {
    this.lastDetailHomonymId = null;
    this.lastListHomonymId = null;
  }

  /******************************************************************************
   * Sajaseungeo
   *****************************************************************************/

  private lastDetailSajaseungeoId: string | null = null;
  private lastListSajaseungeoId: string | null = null;

  public setLastSajaseungeoId(detail_id: string | null, list_id: string | null): void {
    // console.warn('setLastSajaseungeoId', detail_id, list_id)
    this.lastDetailSajaseungeoId = detail_id;
    this.lastListSajaseungeoId = list_id;
  }

  public getLastSajaseungeoId(): [string | null, string | null] {
    // console.warn('getLastSajaseungeoId', this.lastDetailSajaseungeoId, this.lastListSajaseungeoId)
    // return [this.lastDetailSajaseungeoId, this.lastListSajaseungeoId];
    return [null, this.lastListSajaseungeoId];
  }

  public clearLastSajaseungeoId(): void {
    this.lastDetailSajaseungeoId = null;
    this.lastListSajaseungeoId = null;
  }

  /******************************************************************************
   * Dialect
   *****************************************************************************/

  private lastDetailDialectId: string | null = null;
  private lastListDialectId: string | null = null;

  public setLastDialectId(detail_id: string | null, list_id: string | null): void {
    console.warn('setLastDialectId', detail_id, list_id)
    this.lastDetailDialectId = detail_id;
    this.lastListDialectId = list_id;
  }

  public getLastDialectId(): [string | null, string | null] {
    console.warn('getLastDialectId', this.lastDetailDialectId, this.lastListDialectId)
    // return [this.lastDetailDialectId, this.lastListDialectId];
    return [null, this.lastListDialectId];
  }

  public clearLastDialectId(): void {
    this.lastDetailDialectId = null;
    this.lastListDialectId = null;
  }

  /******************************************************************************
   * Proverb
   *****************************************************************************/
  private lastDetailProverbId: string | null = null;
  private lastListProverbId: string | null = null;

  public setLastProverbId(detail_id: string | null, list_id: string | null): void {
    console.warn('setLastProverbId', detail_id, list_id)
    this.lastDetailProverbId = detail_id;
    this.lastListProverbId = list_id;
  }

  public getLastProverbId(): [string | null, string | null] {
    console.warn('getLastProverbId', this.lastDetailProverbId, this.lastListProverbId)
    // return [this.lastDetailProverbId, this.lastListProverbId];
    return [null, this.lastListProverbId];
  }

  public clearLastProverbId(): void {
    this.lastDetailProverbId = null;
    this.lastListProverbId = null;
  }
}
